import { differenceInDays, parseISO } from 'date-fns';
import { sprintf } from 'sprintf-js';

import { ApiISODateTimeString } from 'api/types/ApiTypedDate';
import { ApplyButton } from 'components/ApplyButton/ApplyButton';
import { Divider } from 'components/Divider/Divider';
import { Hide } from 'components/Hide/Hide';
import { Text } from 'components/Text/Text';
import { Tooltip } from 'components/Tooltip/Tooltip';
import { ClientOnly } from 'containers/ClientOnly';
import { distanceInWordsToNow } from 'utils/date';

type ListingSidebarContentProps = {
  firstPublished: ApiISODateTimeString | null;
  isPreview?: boolean;
  isExpired: boolean;
  hasAts: boolean;
  listingId: string;
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'EVENT';
};

export function ListingViewSidebarContent({
  firstPublished,
  isPreview = false,
  isExpired,
  hasAts,
  listingId,
  listingType,
}: ListingSidebarContentProps) {
  return (
    <>
      {firstPublished && !isPreview && (
        <div>
          {differenceInDays(parseISO(firstPublished), new Date()) < 2 && (
            <>
              <Text
                fontWeight="semiBold"
                color="mediumContentGrey"
                borderBottom="4px solid"
                borderColor="brandYellow"
                display="inline-block"
                lineHeight="6px"
                ml="0px"
                mr="12px"
                p="0px"
              >
                {getText('New')}
              </Text>
              <Text
                display={[
                  'inline-block',
                  'inline-block',
                  'inline-block',
                  'none',
                ]}
                color="lightContentGrey"
                pl={2}
                pr={2}
              >
                |
              </Text>
            </>
          )}
          <Text display="inline-block" color="lightContentGrey">
            <ClientOnly>
              {
                /* TRANSLATORS: Listing page - time published */
                sprintf(getText('Published %(timeAgo)s'), {
                  timeAgo: distanceInWordsToNow(firstPublished),
                })
              }
            </ClientOnly>
          </Text>
        </div>
      )}

      {listingType !== 'EVENT' && !isExpired && (
        <Hide xs sm md>
          <Tooltip
            content={getText("You can't take this action in Preview Mode")}
            triggerCondition={isPreview}
            variant="filled"
            placement="bottom-center"
            size="large"
          >
            <div
              style={{
                marginTop: 24,
                cursor: isPreview ? 'not-allowed' : undefined,
                pointerEvents: isPreview ? 'none' : undefined,
              }}
            >
              <ApplyButton
                tabIndex={isPreview ? -1 : undefined}
                atsIsEnabled={hasAts}
                listingId={listingId}
                size="medium"
              />
            </div>
          </Tooltip>
        </Hide>
      )}

      <Divider marginTop={24} marginBottom={24} />
    </>
  );
}
